<template>
    <v-content class="bg-content">
     <div id="app">
      <v-container grid-list-xl style="padding: 10px; top: -40px">
        <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="75"
            height="75"
            elevation="3"
            dense
            dark
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/DashIcon.png">
                        </v-avatar>
              Cogneetiv Ideation
            </v-toolbar-title>

            <v-spacer></v-spacer>
    <button class="paste-button" @click="setEditorContent">Paste Generated Content</button>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              value="Go Back From Whence You Came!"
              onclick="history.back(-1)"
              >Previous Page</v-btn
            >
          </v-app-bar>
        </v-card>
        </v-container>
        
      <v-container grid-list-xl style="padding: 10px; top: 10px;">
       <v-layout row wrap class="card-animate-2">
        <v-flex xs12 sm12 md12 xl9>
          <vue-editor id="editor"
            useCustomImageHandler
            @imageAdded="handleImageAdded" v-model="content">
          </vue-editor>
        </v-flex>
        <v-flex xs12 sm12 md12 xl3>
          <v-form
                    ref="invoiceform"
                    lazy-validation
                    aria-autocomplete="off"
                    class="form-control-2"
                  >
              
                    <form ref="form" @submit.prevent="sendEmail">

                    <v-row fluid>

                   <v-button class="button">
              <v-toolbar-title style="padding: 0px;">
                <v-avatar size="40">
                  <img src="@/assets/EmailIcon.png" />
                </v-avatar>
                    Share Idea
              </v-toolbar-title>
                    <div class="field">
                    <label>Content</label>
                    <input class="chart-title" type="text" v-model="content" name="user_content">
                    <label>Email</label>
                    <input class="chart-title-4" type="email" v-model="formFields.email" name="user_email">
                    <input class="submit" type="submit" @click="submitForm2" value="Send">
                    <span class="submit"></span>
                    <span class="loading"><i class="fa fa-spinner fa-spin"></i></span>
                    <span class="check"><i class="fa fa-check"></i></span>
                    </div>
                    </v-button>
                    </v-row>

                    </form>                
                  </v-form>
        </v-flex>
       </v-layout>
      </v-container>
            <v-container grid-list-xl style="padding: 10px; top: 400px;">
            <!-- <div>{{ content }}</div> -->
            
      </v-container>
      </div>


       <v-container grid-list-xl style="padding: 10px; top: 50px;">
      <v-dialog v-model="showEmailConfirmation" max-width="1980px" max-height="250">
        <v-card class="theme-bg-card-6">
              <v-toolbar-title style="padding: 16px;">
                <v-avatar class="card-animate-2" size="100">
                  <img src="@/assets/DashIcon.png" />
                </v-avatar>
              </v-toolbar-title>
              
          <v-spacer></v-spacer><v-spacer></v-spacer>

    <h1 class="user-speach">
      <v-flex class="space" />   
      <h1 class="typing2">
        <span>{{ speak }}</span>
      </h1>
    </h1>

        </v-card>
      </v-dialog>

        </v-container>

    </v-content>
</template>

<script>
import emailjs from '@emailjs/browser';
import {VueEditor} from 'vue2-editor'
import axios from 'axios'
import store from '../store';
import dateCommand from '../utility';
export default {
  name: 'app',
  components: {
    VueEditor
  },
  data() {
    return {
      editorContent: null,  
      content: null,
      sortBy: 'fat',
      sortDesc: false,
      scrollInvoked: 0,
      dashboard: {},
      items: [],
      contact_list: [],
      account_list: [],
      invoicesList: [],
      productsList: [],
      searchKey: '',
      search: '',
      searchAccountName: '',
      searchContactName: '',
      showAccountForm: false,
      showContactForm: false,
      optionIndex: 0,
      itemToBeDeleted: '',
      loading3: false,
      isLoading: false,
      productLoader: false,
      editForm: false,
      showConfirmation: false,
      showEmailConfirmation: false,
      overlay: false,
      overlay2: false,
      itemsPerPage: 10,
      currentField: 0,
      tableLoader: false,
      date: new Date(),
      selectedAccountDetails: {},
      selectedContactDetails: {},
      selectedProductInfo: {},
      formFields: {
        invoiceSubject: '',
        invoiceStatus: '',
        invoiceOwner: '',
        accountName: '',
        company: '',
        contactName: '',
        accountType: '',
        paymentType: '',
        email: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
        invoiceDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        invoiceDue: '',
        subtotal: '',
        discount: 0,
        tax: 9.5,
        total: '',
        imei: '',
        productsList: [],
      },
      inputs: [
        {
        Make: '',
        Model: '',
        price: '',
        quantity: '',
        amount: '',
        IMEI: '',
        Memory: '',
        Carrier: '',
        Color: '',
        },
      ],
      modal_date_picker: false,
      form_valid: true,
      headers: [
        {
          text: 'Account Name',
          value: 'accountName',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Account Type',
          value: 'accountType',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Date',
          value: 'invoiceDate',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Grand Total',
          value: 'total',
          align: 'center',
          sortable: false,
          divider: true,
          itemsLength: 0,
        },
        {
          text: 'Payment Type',
          value: 'paymentType',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: 'Quantity',
          value: 'quantity',
          align: 'center',
          sortable: true,
          divider: true,
        },
        {
          text: '',
          value: 'controls',
          align: 'center',
          sortable: false,
          divider: true,
        },
      ],
    };
  },
  mounted() {
    Event.$on('showCard', (data) => {
      console.log(data);
      if (data.msg.indexOf('calendar') != -1) {
        this.type = 'calendar';
      }
      this.overlay = true;
    });
    Event.$on('showEmail', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('email') != -1) {
        this.type = 'email';
      }
      this.overlay = true;
    });
    Event.$on('showApple', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('apple') != -1) {
        this.type = 'apple';
      }
      this.overlay = true;
    });
    Event.$on('showSamsung', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('samsung') != -1) {
        this.type = 'samsung';
      }
      this.overlay = true;
    });
    Event.$on('playMix', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('mix') != -1) {
        this.type = 'mix';
      }
      this.overlay = true;
    });
    Event.$on('playNight', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('night') != -1) {
        this.type = 'night';
      }
      this.overlay = true;
    });
    Event.$on('playChill', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('chill') != -1) {
        this.type = 'chill';
      }
      this.overlay = true;
    });
    Event.$on('playSmooth', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('smooth') != -1) {
        this.type = 'smooth';
      }
      this.overlay = true;
    });
    Event.$on('playCyber', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      if (data.msg.indexOf('cyber') != -1) {
        this.type = 'cyber';
      }
      this.overlay = true;
    });
    Event.$on('closeCard', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data);
      this.overlay = false;
    });    
    this.getDashboard();
    this.getInvoicesList();
    Event.$on('openForm', () => {
      // Event.$off();
      console.log('Starting form in ' + this.$route.path);
      if (this.$route.path !== '/invoices') {
        return;
      }
      this.readOutLoud('Please fill the following details');
      setTimeout(() => {
        this.readOutLoud('Company Name');
        this.startListining();
      }, 3000);
      this.overlay = true;
    });
    Event.$on('editFromRecord', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(data.msg);
      this.editInvoice(this.invoicesList[0]);
    });
    Event.$on('searchFromRecord', (data) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      this.search = data.msg;
      this.searchInvoice(data.msg);
    });
    Event.$on('generateInvoice', (msg) => {
      if (this.$route.path !== '/invoices') {
        return;
      }
      console.log(msg);
      if (this.overlay) {
        this.createInvoice();
      }
    });
    Event.$on('formDetails', (data) => {
      console.log(data);
      switch (data.msg) {
        case 'next':
          this.currentField++;
          this.navigateField();
          break;
        case 'previous':
          this.currentField--;
          this.navigateField();
          break;
        case 'submit':
          this.readOutLoud('Please verify your invoice details');
          break;
        case 'verified':
          this.overlay = false;
          this.submitForm();
          break;
        default:
          this.fillForm(data.msg);
          break;
      }
    });
  },
  printInvoice: function() {
    window.print();
  },
  watch: {
    searchAccountName(val) {
      if (!val) return;
      this.isLoading = true;
      fetch(`${process.env.VUE_APP_NODE_SERVER}account-form/search`, {
        method: 'POST',
        body: JSON.stringify({ searchText: val }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.clone().json())
        .then((res) => {
          this.account_list = res.result;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    searchContactName(val) {
      // Items have already been loaded
      // if(!val) return
      // if (this.contact_list.length > 0) return;
      this.isLoading = true;
      fetch(`${process.env.VUE_APP_NODE_SERVER}contact-form/search`, {
        method: 'POST',
        body: JSON.stringify({ searchText: val }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.clone().json())
        .then((res) => {
          this.contact_list = res.result;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    selectedAccountDetails(val) {
      if (!val) return;
      this.formFields.email = val.email ? val.email : '';
      this.formFields.accountName = val.accountName ? val.accountName : '';
      this.formFields.street = val.street ? val.street : '';
      this.formFields.city = val.city ? val.city : '';
      this.formFields.state = val.state ? val.state : '';
      this.formFields.zipcode = val.zipcode ? val.zipcode : '';
      this.formFields.accountType = val.accountType ? val.accountType : '';
      this.contact_list.push(this.formFields);
      this.account_list.push(this.formFields);
    },
  },
  methods: {
    setEditorContent() {
      this.content = store.state.message;
    },
    handleImageAdded(file, Editor, cursorLocation) {
      const CLIENT_ID = '993793b1d8d3e2e'
      var formData = new FormData();
      formData.append('image', file)
      axios({
        url: 'https://api.imgur.com/3/image',
        method: 'POST',
        headers:{
          'Authorization': 'Client-ID ' + CLIENT_ID
        },
        data: formData
      })
      .then((result) => {
        console.log(result);
        let url = result.data.data.link
        Editor.insertEmbed(cursorLocation, 'image', url);
      })
      .catch((err) => {
        console.log(err);
      })
    },
   sendEmail() {
      emailjs.sendForm('service_7tk19m9', 'cogneetivIdeation', this.$refs.form, 'user_odKCu76HuvCXramvgkSwn')
        .then((result) => {
            console.log('SUCCESS!', result.text);
        }, (error) => {
            console.log('FAILED...', error.text);
        });
    },
    toggleOrder() {
      this.sortDesc = !this.sortDesc;
    },
    nextSort() {
      let index = this.headers.findIndex((h) => h.value === this.sortBy);
      index = (index + 1) % this.headers.length;
      this.sortBy = this.headers[index].value;
    },
    initialize() {
      this.InvoicesList = [];
    },
    getDashboard: async function() {
      const rawResponse = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}analytics/all`
      );
      const content = await rawResponse.json();
      this.dashboard = content.response;
      console.log(content);
    },
    add() {
      this.inputs.push({
        Make: '',
        Model: '',
        price: '',
        quantity: '',
        amount: '',
        IMEI: '',
        Memory: '',
        Carrier: '',
        Color: '',
      });
      console.log(this.inputs);
      this.productsList = [];
    },
    remove(index) {
      this.inputs.splice(index, 1);
      this.productsList = [];
    },
    onScroll() {
      this.scrollInvoked++;
    },
    selectProduct(product, i) {
      console.log(product);
      this.inputs[i].Make = product.Make;
      this.inputs[i].Model = product.Model;
      this.inputs[i].IMEI = product.IMEI;
      this.inputs[i].Memory = product.Memory;
      this.inputs[i].Carrier = product.Carrier;
      this.inputs[i].Color = product.Color;
      this.inputs[i].price = product.price;
      this.inputs[i].quantity = product.quantity;
      this.productsList = [];
      this.selectedProductInfo = product;
      this.type = '';
    },
    searchProducts(event, index, type) {
      if (!event.target.value) return;
      this.productLoader = true;
      this.optionIndex = index;
      this.type = type;
      if (type == 'product') {
        setTimeout(() => {
          fetch(`${process.env.VUE_APP_NODE_SERVER}product-master/search`, {
            method: 'POST',
            body: JSON.stringify({ searchText: event.target.value }), // string or object
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          })
            .then((res) => res.clone().json())
            .then((res) => {
              this.productsList = res.result;
              this.productLoader = false;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.productLoader = false));
        }, 1000);
      } else if (type == 'imei') {
        setTimeout(() => {
          fetch(
            `${process.env.VUE_APP_NODE_SERVER}product-master/iemi-search`,
            {
              method: 'POST',
              body: JSON.stringify({ searchText: event.target.value }), // string or object
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          )
            .then((res) => res.clone().json())
            .then((res) => {
              this.productsList = res.result;
              this.productLoader = false;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.productLoader = false));
        }, 1000);
      }
    },
    handleTotal() {
      if (this.inputs.length) {
        this.formFields.subtotal = this.inputs.reduce(
          (accum, item) => accum + +item.amount,
          0
        );
      }
      this.formFields.total =
        this.formFields.subtotal * this.formFields.tax / 100 +
        this.formFields.subtotal -
        this.formFields.discount;
    },
    searchInvoice: async function() {
      console.log(this.search);
      if (!this.search) this.getInvoicesList();
      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;
      console.log(json);
      this.invoicesList = json.result;
    },
    getInvoicesList: async function() {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/all`
      );
      const json = await response.json();
      console.log(json);
      this.invoicesList = json.result;
      this.dashboard.accounts = this.invoicesList.reduce(
        (acc, o) => ((acc[o.accountName] = (acc[o.accountName] || 0) + 1), acc),
        {}
      );
      this.dashboard.accounts = Object.keys(this.dashboard.accounts).length;
      this.tableLoader = false;
    },
    updateProductStatus: async function() {
      this.selectedProductInfo.status = 'Sold';
      this.selectedProductInfo.SellingPrice = this.formFields.total;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}product-master/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.selectedProductInfo), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response);
    },




    submitForm2: async function() {
      this.isLoading = true;
      setTimeout(() => {
        this.readOutLoud('Successfuly emailed generated Ideas');
        this.buttonLoader = true;
        this.showEmailConfirmation = true;
        this.resetForm();
      }, 2000);
    },


    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])
      this.formFields.accountName = this.selectedAccountDetails.accountName;
      this.formFields.contactName = this.selectedContactDetails.contactName;
      if (!this.inputs[0].Make) {
        this.$notify({
          group: 'foo',
          title: 'Important message',
          text: 'Please add products',
        });
        return;
      }
      console.log(this.selectedAccountDetails);
      console.log(this.selectedContactDetails);
      this.formFields.productsList = this.inputs;
      this.formFields.quantity = this.inputs.length;
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.updateProductStatus();
      setTimeout(() => {
        this.readOutLoud('Invoice Created');
        this.getInvoicesList();
        this.resetForm();
      }, 800);
    },
    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },
    deleteInvoice: async function() {
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;
      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getInvoicesList();
      }, 800);
    },
    editInvoice: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
      this.inputs = data.productsList;
      this.selectedAccountDetails = this.formFields;
      this.selectedContactDetails = this.formFields;
      console.log(this.formFields.accountName);
      console.log(this.formFields.contactName);
    },
    updateInvoice: async function() {
      this.loading3 = true;
      this.formFields.accountName = this.selectedAccountDetails.accountName;
      this.formFields.contactName = this.selectedContactDetails.contactName;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getInvoicesList();
        this.resetForm();
      }, 800);
    },
    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.inputs = [
        {
        Make: '',
        Model: '',
        price: '',
        quantity: '',
        amount: '',
        IMEI: '',
        Memory: '',
        Carrier: '',
        Color: '',
        },
      ];
      this.formFields = {
        invoiceSubject: '',
        invoiceStatus: '',
        invoiceOwner: '',
        accountName: '',
        company: '',
        contactName: '',
        accountSource: '',
        accountType: '',
        paymentType: '',
        email: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
        invoiceDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        subTotal: '',
        total: '',
        quantity: 0,
        discount: 0,
        imei: '',
        tax: 9.5,
        productsList: [],
      };
    },
    openForm: function() {
      this.overlay = true;
      this.items = [];
      this.selectedProductInfo = [];
    },
    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1250);
    },
    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },
    readOutLoud: function(msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.text = msg;
      speech.lang = 'en-GB';
      window.speechSynthesis.speak(speech);
      this.speak = msg;
    },
    fillForm: function(msg) {
      switch (this.currentField) {
        case 0:
          //Owner Name
          var owner = this.ownerOptions.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (owner) {
            this.formFields.invoiceOwner = owner;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 1:
          this.formFields.invoiceDate = dateCommand(msg);
          this.currentField++;
          break;
        case 2:
          this.formFields.invoiceSubject = msg;
          this.currentField++;
          break;
        case 3:
          var accountType = this.accountType.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (accountType) {
            this.formFields.accountType = accountType;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 4:
          this.formFields.accountName = msg;
          this.currentField++;
          break;
        case 5:
          var paymentType = this.paymentType.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (paymentType) {
            this.formFields.paymentType = paymentType;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 6:
          this.formFields.contactName = msg;
          this.currentField++;
          break;
        case 7:
          var invoiceStatus = this.invoiceStatus.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (invoiceStatus) {
            this.formFields.invoiceStatus = invoiceStatus;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 8:
          this.formFields.street = msg;
          this.currentField++;
          break;
        case 9:
          this.formFields.state = msg;
          this.currentField++;
          break;
        case 10:
          this.formFields.city = msg;
          this.currentField++;
          break;
        case 11:
          this.formFields.zipcode = msg;
          this.currentField++;
          break;
        case 12:
          this.input.IMEI = msg;
          this.currentField++;
          break;
      }
      this.navigateField();
    },
    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('Invoice Owner?');
          break;
        case 1:
          this.readOutLoud('Invoice Date?');
          break;
        case 2:
          this.readOutLoud('Invoice Subject?');
          break;
        case 3:
          this.readOutLoud('Account Type?');
          break;
        case 4:
          this.readOutLoud('Account Name?');
          break;
        case 5:
          this.readOutLoud('Payment Type?');
          break;
        case 6:
          this.readOutLoud('Contact Name?');
          break;
        case 7:
          this.readOutLoud('Invoice Status?');
          break;
        case 8:
          this.readOutLoud('Street?');
          break;
        case 9:
          this.readOutLoud('State ?');
          break;
        case 10:
          this.readOutLoud('City ?');
          break;
        case 11:
          this.readOutLoud('Zip code ?');
          break;
        case 12:
          this.readOutLoud('IMEI?');
          break;
      }
      this.startListining();
    },
  },
};
</script>


<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.12.0/styles/default.min.css";
#editor {
  height: 430px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #d4c3c3;
  /*margin-top: 60px;*/
  /* max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 3em; */
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style scoped>
.bg-content {
    background: #131f25e7;
    padding: 0px;
    min-height: 88vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 150%;
    }
    
    @media only screen and (max-width: 600px) {
     .bg-content {
    background: #0c161bb2;
    padding: 20px;
    min-height: 120vh;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 150%;
    } 
  }
.space {
  height: 30px;
}
.avatar-name {
  position: relative;
  top: 10px;
  font-weight: 600;
  margin-left: 8px;
  margin-right: 5px;
}
.user-speach {
  position: center;
  font-size: 12px;
  min-width: 0%;
  max-width: 120%;
  bottom: 15px;
  height: 75px;
  float: inherit;
  left: 0px;
  right: 0px;
  border-radius: 20px;
  padding: 15px;
  color: #fff;
  /* transform: translate(-0%, -50%); */
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@media (min-width: 600px) {
  .user-speach {
    position: absolute;
    font-size: 15px;
    min-width: 0%;
    max-width: 120%;
    bottom: 30px;
    height: 75px;
    float: inherit;
    left: 0.5%;
    border-radius: 20px;
    padding: 10px;
    color: #fff;
    /* transform: translate(-0%, -50%); */
  }

  @-webkit-keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
}

.btn-text {
  cursor: pointer;
  display: inline-block;
  font-size: 8px;
  font-weight: 100;
  line-height: 1.42857;
  margin-bottom: 0;
  padding: 3px 3px;
  text-align: center;
  vertical-align: middle;
}
@media (min-width: 600px) {
  .btn-text {
    cursor: pointer;
    display: inline-block;
    font-size: 11px;
    font-weight: 300;
    line-height: 1.42857;
    margin-bottom: 0;
    padding: 6px 6px;
    text-align: center;
    vertical-align: middle;
  }
}
.about {
  padding: 0px;
  width: 100%;
}
.db-content {
  background: #304057;
  background-size: 400% 400%;
  padding: 40px;
  min-height: 88vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
.btn-right {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
.mg-lr14 {
  margin: 0px 14px;
}
.scroll {
  overflow-y: scroll;
  height: 100%;
}
.theme-bg-card {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 400px;
}
.theme-bg-card:hover {
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
    inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}
.theme-bg-card-2 {
  background: rgba(12, 22, 27, 0.0);
  outline-color: #5a80bf;
  color: rgb(255, 255, 255);
  padding: 10px; 
  top:20px
}
@media only screen and (max-width: 600px) {
  .theme-bg-card-2 {
    background: rgba(12, 22, 27, 0.0);
    outline-color: #5a80bf;
    color: rgb(255, 255, 255);
    padding: 10px; 
    top:0px
  }
}
.theme-bg-card-3 {
  background: rgba(48, 64, 87, 0.5);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 68vh;
  top: -7rem;
}

.theme-bg-card-3:hover {
  background: rgba(48, 64, 87, 0.9);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
    inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
}

/* .theme-bg-card-3:hover {
  background: rgba(48, 64, 87, 0.9);
  outline-color: #42da91;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #42da91;
  box-shadow: 0 0 10px rgba(90, 128, 191, 0.2),
    inset 0 0 10px rgba(90, 128, 191, 0.1), 0 0px 0 #000;
  color: #efe;
  outline: 20px;
} */
.theme-bg-card-4 {
  background: rgba(48, 64, 87, 0.85);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 10vh;
  border-radius: 30px;
}

.theme-bg-card-5 {
  background: rgba(48, 64, 87, 0.6);
  outline-color: #5a80bf;
  color: #fff;
}


@media only screen and (max-width: 600px) {
.theme-bg-card-5 {
  background: rgba(48, 64, 87, 0.6);
  outline-color: #5a80bf;
  color: #fff;
}
}
.theme-bg-card-6 {
  background: rgba(12, 22, 27, 0.4);
  outline-color: #5a80bf;
  color: #fff;
  height: 200px;
}
.chart-text {
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: 'Courier New', Courier, monospace;
}
.tile-title {
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
.chart-title {
  color: #fff;
  text-align: center;
  font-weight: normal;
  font-family: Arimo, sans-serif;
  padding: 10px;
}
@media only screen and (max-width: 600px) {
  .chart-title {
    color: #fff;
    text-align: center;
    font-size: 0.9rem;
    font-weight: bold;
    font-family: Arimo, sans-serif;
  }
}

.chart-title-4 {
  color: #fff;
  text-align: center;
  font-size: 0.4rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
  padding: 10px;
}
@media only screen and (max-width: 600px) {
  .chart-title-4 {
    color: #fff;
    text-align: center;
    font-size: 0.9rem;
    font-weight: bold;
    font-family: Arimo, sans-serif;
  }
}

.theme-bg-card-5 {
  background: rgba(48, 64, 87, 0.0);
  border-radius: 25px;
  width: 35%;

}


@media only screen and (max-width: 600px) {
.theme-bg-card-5 {
  background: rgba(48, 64, 87, 0.6);

  width: 50%;
}
}
.field {
  margin-bottom: 30px;
  padding: 30px;
  border-radius: 20px;
    border-color: rgb(36, 212, 65);
  border-radius: 20px;
  padding-block: 20px;
  margin-block: 5px;
  border: 1px solid transparent;

}

.field label {
  display: block;
  font-size: 12px;
  color: rgb(255, 255, 255);
}

.field input {
  display: block;
  min-width: 500px;
  line-height: 2.5;
  font-size: 13px;
  color: rgb(36, 212, 65);
  border-radius: 20px;
  padding-block: 10px;
  margin-block: 5px;
  border: 1px solid transparent;
}

input[type="submit"] {
  display: block;
  padding: 10px 40px;
  font-size: 14px;
  background-color: rgb(36, 212, 65);
  color: #fff;
  border: none;
  background: rgb(36, 212, 65, 0.4);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  height: 50px;
}


.chart-title-2 {
  text-align: center;
  font-size: 1.3rem;
  font-weight: 500;
  color: #42da91;
  font-family: Arial, Helvetica, sans-serif;
  padding: 20px;
}
@media only screen and (max-width: 600px) {
  .chart-title-2 {
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: #42da91;
    font-family: Arial, Helvetica, sans-serif;
    padding: 5px;
  }
}

.field {
  margin-bottom: 30px;
  padding: 30px;
  border-radius: 20px;

}

.field label {
  display: block;
  font-size: 16px;
  color: rgb(255, 255, 255);
}

.field input {
  display: block;
  min-width: 500px;
  line-height: 2.5;
  font-size: 16px;
  color: rgb(36, 212, 65);
  border-radius: 20px;
  padding-block: 20px;
  margin-block: 5px;
  border: 1px solid transparent;
}

input[type="submit"] {
  display: block;
  padding: 10px 40px;
  font-size: 14px;
  background-color: #4460AA;
  color: #fff;
  border: none;
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  height: 50px;
}
/* 
.button {
  border-radius: 30px;
  padding: 8px;
  width: 3px;
  border: outline;
  background: #304057;
  opacity: 0.9;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  align: center;
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }
    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
@media only screen and (max-width: 600px) {
  
.button {
  border-radius: 40px;
  padding: 5px;
  width: 5px;
  border: outline;
  background: #304057;
  opacity: 0.9;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  align: center;
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }
    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }
} */

.button2  {
  border-radius: 30px;
  padding:  0px;
  border: outline;
  background: #304057;
  opacity: 0.9;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;
  outline-color: #5a80bf;
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
    inset 0 0 3px rgba(90, 128, 191, 0.1), 0 2px 0 #000;
  outline: none;
  }
  @keyframes glow {
    0% {
      border-color: #11ece5;
      box-shadow: 0 0 5px rgba(90, 128, 191, 0.2),
        inset 0 0 6px rgba(90, 128, 191, 0.4), 0 2px 0 #000;
    }
    100% {
      border-color: #11ece5;
      box-shadow: 0 0 8px rgba(90, 128, 191, 0.8),
        inset 0 0 10px rgba(90, 128, 191, 0.8), 0 2px 0 #000;
    }
  }

.chart-content {
  opacity: 0.7;
  text-align: center;
  margin-left: 0%;
  top: -75px;
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 15px;
  border-radius: 10px;
  margin: 10px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}


.thrash {
  font-size: 20px;
  cursor: pointer;
}
.theme-bg-card-3 {
  background: rgba(48, 64, 87, 0.5);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.3);
  height: 68vh;
  top: -7rem;
}

.card-animate-2 {
  animation-name: slideExpandUp;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 3s;
  transition: opacity 1s Elastic.easeIn;
}

.slideExpandUp {
  animation-name: slideExpandUp;
  -webkit-animation-name: slideExpandUp;

  animation-duration: 2.7s;
  -webkit-animation-duration: 2.7s;

  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;

  visibility: visible !important;
}

@keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}

@-webkit-keyframes slideExpandUp {
  0% {
    -webkit-transform: translateY(10%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-5%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(3%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}
.space {
  height: 20px;
}

.card-animate {
  animation-name: slideExpandDown;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 3s;
  transition: opacity 1s Elastic.easeIn;
}
.slideExpandDown {
  animation-name: slideExpandDown;
  -webkit-animation-name: slideExpandDown;
  animation-duration: 2.7s;
  -webkit-animation-duration: 2.7s;
  animation-timing-function: ease-out;
  -webkit-animation-timing-function: ease -out;
  visibility: visible !important;
}
@keyframes slideExpandDown {
  0% {
    transform: translateY(100%) scaleX(0.94);
  }
  30% {
    transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    transform: translateY(2%) scaleX(0.96);
  }
  50% {
    transform: translateY(0%) scaleX(1);
  }
}
@-webkit-keyframes slideExpandDown {
  0% {
    -webkit-transform: translateY(100%) scaleX(0.94);
  }
  30% {
    -webkit-transform: translateY(-4%) scaleX(0.95);
  }
  40% {
    -webkit-transform: translateY(2%) scaleX(0.96);
  }
  50% {
    -webkit-transform: translateY(0%) scaleX(1);
  }
}
.popup-container {
  max-height: 90vh;
  width: 90vw;
  background: rgba(48, 64, 87, 0.6);
  padding: 10px 40px;
}
.font-weight-thin {
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-weight: 600;
}
.d-flex-row {
  display: flex;
  flex-direction: row;
}
.d-flex-col {
  display: flex;
  flex-direction: column;
}
.date-picker {
  flex: 1 1 0%;
  padding: 17px;
  border: 1px solid #fff;
  height: 53px;
  width: auto;
  color: #fff;
  margin: 0 14px;
  border-radius: 5px;
}
.form-control {
  border: 1px solid #5e6570;
  padding: 20px 20px;
  margin-block: 3px 5px;
  border-radius: 5px;
  font-size: 14px;
  background: transparent;
  color: rgb(36, 212, 65);
}
@media only screen and (max-width: 600px) {
 .form-control {
  border: 1px solid #5e6570;
  padding: 20px 20px;
  margin-block: 3px 5px;
  border-radius: 10px;
  font-size: 12px;
  background: transparent;
  color: rgb(36, 212, 65);
 }
}
.form-control-2 {
  border: 1px solid #5e6570;
  padding: 10px 10px;
  border-radius: 5px;
  font-size: 14px;
  background: transparent;
  color: rgb(255, 255, 255);
  
}
@media only screen and (max-width: 600px) {
 .form-control-2 {
  border: 1px solid #5e6570;
  padding: 20px 20px;
  margin-block: 3px 5px;
  border-radius: 10px;
  font-size: 12px;
  background: transparent;
  color: rgb(36, 212, 65);
 }
}
.form-control-3 {
  display: block;
  min-width: 480px;
  line-height: 2.5;
  font-size: 18px;
  color: rgb(36, 212, 65);
  border-radius: 20px;
  padding-block: 20px;
  margin-block: 5px;
  border: 1px solid transparent;
}
@media only screen and (max-width: 600px) {
 .form-control-3 {
  display: block;
  min-width: 480px;
  line-height: 2.5;
  font-size: 16px;
  color: rgb(36, 212, 65);
  border-radius: 20px;
  padding-block: 20px;
  margin-block: 5px;
  border: 1px solid transparent;
 }
}
.space2 {
  height: 50px;
}
.action-btn {
  font-size: 20px;
  cursor: pointer;
  position: relative;
  top: 5px;
}
.typing {
  padding: 15px;
  /* background: rgba(37, 50, 68, 0.6);
    border-radius: 15px; */
  border-radius: 20px;
  min-width: 0%;
  margin-left: 0px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;
  background: rgba(37, 50, 68, 0.2);
  -webkit-animation: titleAnimation 20s infinite ease;
  -animation: titleAnimation 100s normal forwards ease-in-out;
}

@keyframes titleAnimation {
  0% {
    transform: translateY(-48px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 80%);
  }
  20% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  80% {
    transform: translateY(0);
    opacity: 1;
    -webkit-clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
    clip-path: polygon(100% 0, 100% 100%, 0 100%, 0 0%);
  }
  100% {
    transform: translateY(50px);
    opacity: 0;
    -webkit-clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
    clip-path: polygon(100% 0, 100% -0%, 0 100%, 0 100%);
  }
}
.typing2 {
  padding: 15px;
  left: 0px;
  right: 0px;
  /* background: rgba(37, 50, 68, 0.6);
    border-radius: 15px; */
  border-radius: 20px;
  min-width: 0%;
  max-width: 90%;
  margin-left: 60px;
  font-family: Arimo, sans-serif;
  font-weight: normal;
  font-size: 1.26em;
}
.product-list {
  position: absolute;
  margin-left: 160px;
  margin-top: 38px;
  width: 50%;
  padding: 0px;
  list-style: none;
  background: rgba(48, 64, 87, 0.3);
  color: rgb(255, 255, 255);
  line-height: 2;
  max-height: 200px;
  overflow: auto;
  border: 1px solid #7c7c7c;
  border-radius: 8px;
}
.item {
  padding: 10px;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}
.item:hover {
  background: rgba(48, 64, 87, 0.8);
}
.calc {
  width: 200px;
  margin-bottom: 20px;
}
.loader {
  border: 3px solid #f3f3f3;
  border-radius: 50%;
  border-top: 3px solid #3498db;
  width: 15px;
  height: 15px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  position: relative;
  margin-top: 12px;
  margin-left: -15px;
}
/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>


<style lang="scss">
$base-duration: 500ms;

// Colors
$color-1: rgba(48, 64, 87, 0.85);
$color-2: rgba(48, 64, 87, 0.2);
$color-3: #2ecc71;

// Breakpoints
$sm: new-breakpoint(min-width 320px);
$med: new-breakpoint(min-width 768px);
$lg: new-breakpoint(min-width 1024px);

*, *:before, *:after {
	box-sizing: border-box;
	outline: none;
}

.hide { display: none;
}

.button {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	margin: 0px;  
	padding: 1.5rem 3.125rem;
	background-color: $color-2;
	border: none;
  border-radius: 0.05rem;
	box-shadow:
		0 -1.25rem 1rem -1.5rem rgba(black, 0.4),
		0 0.5rem 1.75rem -0.25rem rgba(black, 0.3),
		0 1.25rem 2.5rem rgba(black, 0.2);
	font-weight: 300;
	text-transform: uppercase;
	transition: $base-duration ease;
	overflow: hidden; 
	
	&:before {
		position: absolute;
		content: '';
		bottom: 0;
		left: 0;
		width: 0%;
		height: 100%;
		background-color: lighten($color-3,10%);
	}
	
	span {
		position: absolute;
		line-height: 0;
		
		i {
			transform-origin: center center;
		}

		&:nth-of-type(1) {
			top: 50%;
			transform: translateY(-50%);
		}
		
		&:nth-of-type(2) {
			top: 100%;
			transform: translateY(0%);
			font-size: 24px;
		}
		
		&:nth-of-type(3) {
			display: none;
		}
	}
}
.active {
	background-color: $color-3;
	
	&:before {
		width: 100%;
		transition: width 3s linear;
	}

	span {
		
		&:nth-of-type(1) {
			top: -100%;
			transform: translateY(-50%); 
		}

		&:nth-of-type(2) {
			top: 50%;
			transform: translateY(-50%);

			i {
				animation: loading $base-duration linear infinite;
			}
		}
		
		&:nth-of-type(3) {
			display: none;
		}
	}
}

.finished {
	background-color: lighten($color-3,10%);
	
	.submit {
		display: none; 
	}
	
	.loading {
		display: none;
	}
	
	.check {
		display: block !important;
		font-size: 24px;
		animation: scale 0.5s linear;
		
		i {
			transform-origin: center center;
		}
	}
	
}

@keyframes loading {
	100% { transform: rotate(360deg); }
}

@keyframes scale {
	0%   { transform: scale(10); }
	50%  { transform: scale(0.2); }
	70%  { transform: scale(1.2); }
	90%  { transform: scale(0.7); }
	100% { transform: scale(1); }
}

@media only screen and (max-width: 600px) {
   .button {
	position: absolute;
	width: 120px;
  height: 250px;
	margin: 0px;  
	padding: 0.5rem 0.5rem;
	background-color: $color-2;
	border: none;
	border-radius: 25px;
  top: -270px; 
  left: 5px;

	// box-shadow:
	// 	0 -1.25rem 1rem -1.5rem rgba(black, 0.4),
	// 	0 0.5rem 1.75rem -0.25rem rgba(black, 0.3),
	// 	0 1.25rem 2.5rem rgba(black, 0.2);
	font-weight: 300;
	text-transform: uppercase;
	transition: $base-duration ease;
	overflow: hidden; 
	
	&:before {
		position: absolute;
		content: '';
		bottom: 0;
		left: 0;
		width: 0%;
		height: 100%;
		background-color: lighten($color-3,10%);
	}
	
	span {
		position: absolute;
		line-height: 0;
		
		i {
			transform-origin: center center;
		}

		&:nth-of-type(1) {
			top: 50%;
			transform: translateY(-50%);
		}
		
		&:nth-of-type(2) {
			top: 100%;
			transform: translateY(0%);
			font-size: 24px;
		}
		
		&:nth-of-type(3) {
			display: none;
		}
	}
}

.active {
	background-color: $color-3;
	
	&:before {
		width: 100%;
		transition: width 3s linear;
	}

	span {
		
		&:nth-of-type(1) {
			top: -100%;
			transform: translateY(-50%); 
		}

		&:nth-of-type(2) {
			top: 50%;
			transform: translateY(-50%);

			i {
				animation: loading $base-duration linear infinite;
			}
		}
		
		&:nth-of-type(3) {
			display: none;
		}
	}
}

.finished {
	background-color: lighten($color-3,10%);
	
	.submit {
		display: none; 
	}
	
	.loading {
		display: none;
	}
	
	.check {
		display: block !important;
		font-size: 24px;
		animation: scale 0.5s linear;
		
		i {
			transform-origin: center center;
		}
	}
	
}

@keyframes loading {
	100% { transform: rotate(360deg); }
}

@keyframes scale {
	0%   { transform: scale(10); }
	50%  { transform: scale(0.2); }
	70%  { transform: scale(1.2); }
	90%  { transform: scale(0.7); }
	100% { transform: scale(1); }
}
}
</style>